import React from 'react';
import {useParams} from 'react-router-dom';
import BannerTemplate from "../../components/templates/BannerTemplate";

export const ArcBannerShow = () => {
    const {id} = useParams<{ id: string }>();
    const numId = Number(id);
    return <BannerTemplate type={'EDIT'} targetId={numId}/>
};
